import React from 'react';
import styled from '@emotion/styled';
import Img01 from 'ui/images/top/topService_img01@2x.png';
import Img02 from 'ui/images/top/topService_img02@2x.png';
import Img03 from 'ui/images/top/topService_img03@2x.png';
import Img04 from 'ui/images/top/topService_img04@2x.png';
import { mqMin } from 'utils/responsive';

const Container = styled.section`
    background-color: var(--lightblue);
    padding: 2rem;
    img {
        max-width: 100%;
    }
`;

const DescriptionContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 88.37209302325581%;
    margin: 0 auto;

    ${mqMin('NARROW')} {
        width: 50rem;
    }

    ${mqMin('NARROW')} {
        width: 956px;
        max-width: initial;
        margin: 0 auto;
    }
`;

const DescriptionItem = styled.div`
    width: 100%;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 8px;
    padding: 24px 0;
    margin-bottom: 12px;

    opacity: 0;
    transform: translateY(30px);
    transition:
        transform 1s cubic-bezier(0.25, 1, 0.5, 1),
        opacity 1s cubic-bezier(0.25, 1, 0.5, 1);

    ${mqMin('SP')} {
        width: 48.42105263157895%;
    }
`;

const ImgItem = styled.img`
    width: auto;
    height: 115px;
    margin: 0 auto 20px auto;
`;

const H3 = styled.h3`
    text-align: center;

    &::after {
        content: '';
        display: block;
        width: 28px;
        height: 2px;
        background-color: var(--dark-blue);
        margin: 12px auto;
    }

    ${mqMin('SP')} {
        font-size: 1.2rem;
    }

    ${mqMin('NARROW')} {
        font-size: 1rem;
    }
`;

const Text = styled.p`
    padding: 0 15px;
    text-align: left;
    font-size: 0.8rem;
    line-height: 1.6em;
    letter-spacing: 0.1em;

    b {
        font-size: 0.9rem;
        font-weight: 900;
    }

    ${mqMin('SP')} {
        font-size: 1.2rem;

        b {
            font-size: 1.3rem;
        }
    }

    ${mqMin('NARROW')} {
        font-size: 0.8rem;

        b {
            font-size: 0.9rem;
        }
    }
`;

export const AboutServiceDetail: React.FC = () => {
    return (
        <Container>
            <DescriptionContainer className="fadeinLi">
                <DescriptionItem>
                    <ImgItem src={Img01} alt="STEP1のイメージ" />
                    <H3>STEP01</H3>
                    <Text>
                        <b>
                            事業承継に関する不安・質問・知りたいことなどを登録（投稿時は匿名となるので、貴社名は公開されません）
                        </b>
                        <br />
                        <br />
                        例）親族承継、従業員承継を検討している場合でも、M&Aについて知っておいた方が良いですか？
                        <br />
                        M&Aの営業を受けているのですが、本当に私はM&Aを検討した方が良いのでしょうか？
                        <br />
                        事業承継の方法はいくつかあると思いますが、それぞれの承継方法のメリットデメリットについて教えてほしいです
                        <br />
                        事業承継はまだ先と考えていますが、いつから情報収集や検討を始めるべきでしょうか
                    </Text>
                </DescriptionItem>
                <DescriptionItem>
                    <ImgItem src={Img02} alt="STEP2のイメージ" />
                    <H3>STEP02</H3>
                    <Text>
                        <b>事業承継専門家から回答オファーが来る</b>
                        <br />
                        <br />
                        例）親族承継、従業員承継とM&Aを比較した中立的なアドバイスが得意なので、是非弊社の話を聞いてみてください。
                        <br />
                        弊社では、M&Aに限らず事業承継のサポートを行っているので、お話させてください。
                        <br />
                        事業承継に関する分かりやすい資料がありますので、是非見ていただきたいです。
                        <br />
                        参考になる他社事例があるので、情報をお渡ししたいです。
                    </Text>
                </DescriptionItem>
                <DescriptionItem>
                    <ImgItem src={Img03} alt="STEP3のイメージ" />
                    <H3>STEP03</H3>
                    <Text>
                        <b>オファーを確認し、話を聞いてみたい専門家からのオファーを了承する</b>
                        <br />
                        <br />
                        （それぞれの会社に合った有益な情報を収集するため、了承相手にのみ貴社名等が開示されます。※当サービスに登録されている事業承継専門家は、秘密保持（守秘義務）に同意済みの専門家です。
                    </Text>
                </DescriptionItem>
                <DescriptionItem>
                    <ImgItem src={Img04} alt="STEP4のイメージ" />
                    <H3>STEP04</H3>
                    <Text>
                        <b>事業承継専門家へ無料で相談。情報収集＆比較検討</b>
                        <br />
                        <br />
                        複数社からの情報を比較することで、納得のいく事業承継の意思決定を行うことが可能
                    </Text>
                </DescriptionItem>
            </DescriptionContainer>
        </Container>
    );
};
